import { useQuery } from "react-query";
import { getWipMeasurements } from "components/measuring/lib/measuring-data";

export const useGetMeasurements = (measuringWipKey) => {
    return useQuery({
        queryKey: ["getMeasurements", measuringWipKey],
        queryFn: () => getWipMeasurements(measuringWipKey),
    });
};
